import {IComponentOptions, IHttpPromiseCallbackArg} from 'angular';
import AuthServiceRS from '../../../authentication/service/AuthServiceRS.rest';
import {OkCancelController} from '../../../core/dialog/OkCancelController';
import {OkHtmlDialogController} from '../../../core/dialog/OkHtmlDialogController';
import {DvDialog} from '../../../core/directive/dv-dialog/dv-dialog';
import BenutzerRS from '../../../core/service/BenutzerRS.rest';
import FondssuisseRS from '../../../core/service/FondssuisseRS.rest';
import TSBenutzer from '../../../models/TSBenutzer';
import TSSerfProperty from '../../../models/TSSerfProperty';
import DVBernUtil from '../../../utils/DVBernUtil';
import {SerfPropertyRS} from '../../service/serfPropertyRS.rest';

require('./konfigurationView.scss');
let template = require('./konfigurationView.html');
let okCancelTemplate = require('../../../core/dialog/okCancelTemplate.html');
let okHtmlDialogTemplate = require('../../../core/dialog/okHtmlDialogTemplate.html');

export class KonfigurationViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    bindings: any = {
        serfProperties: '<',
        sachbearbeiterList: '<',
        adminList: '<'
    };
    template: string = template;
    controller: any = KonfigurationViewController;
    controllerAs: string = 'vm';
}

export class KonfigurationViewController {
    static $inject = ['FondssuisseRS', 'MAX_LENGTH', 'DvDialog', 'AuthServiceRS', 'SerfPropertyRS', 'BenutzerRS'];

    length: number;

    sachbearbeiterList: Array<TSBenutzer>;
    sachbearbeiterToAdd: TSBenutzer | undefined;

    adminList: Array<TSBenutzer>;
    adminToAdd: TSBenutzer | undefined;

    benutzerEmail: string | undefined;

    serfProperty: TSSerfProperty = new TSSerfProperty();
    serfProperties: TSSerfProperty[];

    /* @ngInject */
    constructor(private fondssuisseRS: FondssuisseRS, MAX_LENGTH: number, private dvDialog: DvDialog,
                private authServiceRS: AuthServiceRS,
                private serfPropertyRS: SerfPropertyRS,
                private benutzerRS: BenutzerRS) {
        this.length = MAX_LENGTH;

    }

    $onInit() {

    }

    submitSerfProperty(): void {
        //testen ob aktuelles property schon gespeichert ist
        if (this.serfProperty && this.serfProperty.name) {
            if (!this.serfProperty.isNew()) {
                this.serfPropertyRS.update(this.serfProperty.name, this.serfProperty.value)
                    .then((response: TSSerfProperty) => {
                        let index = DVBernUtil.getIndexOfElementwithIDById(response.id, this.serfProperties);
                        this.serfProperties[index] = response;
                    });

            } else {

                this.serfPropertyRS.create(this.serfProperty.name, this.serfProperty.value)
                    .then((response: any) => {
                        this.serfProperties = this.serfProperties.concat(response);
                    });
            }
            this.resetForm();
        }
    }

    removeSerfProperty(serfProperty: TSSerfProperty): void {
        if (serfProperty.name) {
            this.serfPropertyRS.remove(serfProperty.name).then((reponse: IHttpPromiseCallbackArg<any>) => {
                let index = this.serfProperties.indexOf(serfProperty);
                if (index !== -1) {
                    this.serfProperties.splice(index, 1);
                    this.resetForm();
                }
            });
        }
    }

    editSerfProperty(serfProperty: TSSerfProperty): void {
        this.serfProperty = serfProperty;
    }

    public removeBetroffeneRole() {
        if (this.benutzerEmail) {
            this.benutzerRS.removeBetroffeneRole(this.benutzerEmail).then((response) => {
                return this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController, {
                    title: 'FS_BETROFFENE_ROLLE_ENTFERNEN',
                    text: 'BETROFFENE_ROLLE_ENTFERNT'
                }).then(() => {
                    //do nothin
                });
            });
        } else {
            return this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController, {
                title: 'EMAIL_UNGUELTIG',
                text: 'BITTE_EMAIL'
            })
        }
        return null;
    }

    resetForm(): void {

        this.serfProperty = new TSSerfProperty();
    }

    public addFSSachbearbeiter() {
        if (this.sachbearbeiterToAdd) {
            this.fondssuisseRS.addFSSachbearbeiterRole(this.sachbearbeiterToAdd.id)
                .then((user: TSBenutzer | undefined) => {
                    if (user !== undefined) {
                        let index = DVBernUtil.getIndexOfElementwithID(user, this.sachbearbeiterList);
                        if (index === -1) {
                            this.sachbearbeiterList.push(user);
                        } //else do nothing
                    }
                });
        }
        this.sachbearbeiterToAdd = undefined;
    }

    public addFSAdmin() {

        if (this.adminToAdd) {
            this.fondssuisseRS.addFSAdminRole(this.adminToAdd.id)
                .then((user: TSBenutzer | undefined) => {
                    if (user !== undefined) {
                        let index = DVBernUtil.getIndexOfElementwithID(user, this.adminList);
                        if (index === -1) {
                            this.adminList.push(user);
                        } //else do nothing
                    }
                });
        }
        this.adminToAdd = undefined;
    }

    public removeSachbearbeiter(benutzer: TSBenutzer, event: any) {

        this.fondssuisseRS.removeFSSachbearbeiterRole(benutzer.id).then((response: any) => {
            if (benutzer) {
                let arrWithoutEle = this.sachbearbeiterList.filter(currentBen => currentBen !== benutzer);
                this.sachbearbeiterList = arrWithoutEle;

            }
        });

    }

    public removeAdmin(benutzer: TSBenutzer, event: any) {
        let loggedInUser = this.authServiceRS.getPrincipal();
        //wenn man sich selber die Rolle wegnimmt zeigen wir noch eine Warnung
        if (loggedInUser && loggedInUser.id === benutzer.id) {

            let text = 'CONFIRM_ROLE_REMOVAL';
            this.dvDialog.showDialog(okCancelTemplate, OkCancelController,
                {text: text})
                .then(() => {   //User confirmed removal
                    this.triggerRemoveFSAdminRole(benutzer);
                })
                .catch(() => {
                });
        } else {
            this.triggerRemoveFSAdminRole(benutzer);
        }

    }

    public triggerRemoveFSAdminRole(benutzer: TSBenutzer) {
        this.fondssuisseRS.removeFSAdminRole(benutzer.id).then((response: any) => {
            if (benutzer) {
                let arrWithoutEle = this.adminList.filter(currentBen => currentBen !== benutzer);
                this.adminList = arrWithoutEle;

            }
        });

    }

    public getVersion(): string {
        return VERSION;
    }

    public getBuildtimestamp(): string {
        return BUILDTSTAMP;
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/component/konfigurationView/konfigurationView.ts